<template>
  <div id="doctor-details">
    
    <v-container fluid class="px-0 search-doctor-banner pb-0 d-flex justify-center align-center" :style="$vuetify.breakpoint.mdAndUp ? 'min-height: 110px' : 'min-height: 100px'">
    </v-container>

    <v-container class="py-0">

      <v-row class="ma-0 pa-0" v-if="$vuetify.breakpoint.smAndDown">
      
        <v-col cols="4" sm="6" md="6" lg="4"  class="ma-0" v-if="doctor.profile_image_path">
          <div class="round_img profile-image" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }">
          </div>
        </v-col>
        <v-col cols="4" sm="3" md="6" lg="4" class="ma-0" v-else>
          <div class="round_img profile-image" style="background-image: url('/general/profile_placeholder.svg')">
          </div>
        </v-col>
        <v-col cols="8" sm="6" md="6" lg="8" class="pt-0 d-flex align-center">
          <v-row>
            <v-col cols="12" class="pa-0">
                <div class="font-26 font-weight-black">
                  {{ doctor.salutation }} {{ doctor.name }}
                </div>
                <div>
                    <span class="font-weight-bold grey--text font-16" v-for="specialization in doctor.specializations"
                        :key="specialization.id">
                      {{ specialization.name }}
                  </span>
                </div>                    
            </v-col>
            <v-col cols="12" class="py-0 pl-0 caption font-weight-bold grey--text">

              <v-icon color="green" v-if="doctor.status == 1">mdi-checkbox-marked-circle</v-icon>
              <span v-if="doctor.status == 1">Registration Verified</span>
              <span v-else class="">Education Not Verified</span>
            </v-col>
            
            
          </v-row>
        </v-col>
        <v-col cols="12" >
              <div class="d-flex flex-row">                            
                <span class="green px-3 card-shadow" style="border-radius:2px;padding-top:6px;padding-bottom:6px;">
                  <v-icon v-if="doctor.percent_recommended" class="ma-0 pa-0 white--text font-14">mdi-thumb-up</v-icon>
                  <span v-if="doctor.percent_recommended" class="font-12 weight-semibold white--text mx-1">{{ doctor.percent_recommended }}%</span>
                  <span v-if="doctor.percent_recommended" class="white--text mr-2">|</span>
                  <span class="font-13 weight-semibold white--text">{{ getRecommendations(doctor) }} </span>
                </span>                    
                 
                  <div style="width:70px;" class="sharethis-inline-share-buttons"></div>                
              
              </div>
             
            
          </v-col>
      </v-row>

      <v-row class="ma-0 pa-0" v-else>

          <v-col cols="12" sm="2" md="3" lg="2"  class="ma-0" >
            <div v-if="doctor.profile_image_path" class="round_img profile-image" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }">
            </div>
            <div v-else class="round_img profile-image" style="background-image: url('/general/profile_placeholder.svg')">
            </div>
          </v-col>
          
          <v-col cols="12" sm="6" md="5" lg="6" class="pt-0 d-flex align-center">
            <v-row no-gutters>              
                
                  <v-col cols="12" md="8" class="pa-0 pl-4">
                      <div class="font-26 font-weight-bold darkergray--text">
                        {{ doctor.salutation }} {{ doctor.name }}
                      </div>
                      <div>
                          <span class="font-weight-bold grey--text font-16" v-for="specialization in doctor.specializations"
                              :key="specialization.id">
                            {{ specialization.name }}
                          </span>
                      </div>                    
                      <div class="mt-1 caption font-weight-bold grey--text">
                        <v-icon v-if="doctor.status == 1" color="green" class="pa-0 ma-0">mdi-checkbox-marked-circle</v-icon>
                        <span v-if="doctor.status == 1">Registration Verified</span>
                        <span v-else>Education Not Verified</span>
                      </div>
                  </v-col>                                  
        
                          
            </v-row>
          </v-col>


          <v-col cols="12" md="5" lg="4" style="margin-top:-20px;">
            <div class="d-flex flex-row">                            
              <span class="green px-3 card-shadow" style="border-radius:2px;padding-top:6px;padding-bottom:6px;">
                <v-icon v-if="doctor.percent_recommended" class="ma-0 pa-0 white--text font-14">mdi-thumb-up</v-icon>
                <span v-if="doctor.percent_recommended" class="font-12 weight-semibold white--text mx-1">{{ doctor.percent_recommended }}%</span>
                <span v-if="doctor.percent_recommended" class="white--text mr-2">|</span>
                <span class="font-13 weight-semibold white--text">{{ getRecommendations(doctor) }} </span>
              </span>                    
              <div style="width:70px;">
                <div class="sharethis-inline-share-buttons"></div>
              </div>              
            </div>
            
          </v-col>

      </v-row>

        <v-row class="ma-0 pa-0">
                <v-col cols="12" md="6" lg="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-card color="#f4f9ff" elevation="0">
                        <v-card-text>
                          <v-row no-gutters class="d-flex justify-space-between">
                            <div>
                              <v-avatar
                                  tile
                                  color="white"
                                  size="36"
                                  class="mr-3"
                              >
                                <v-icon color="primary">
                                  mdi-information-outline
                                </v-icon>
                              </v-avatar>
                              <span class="font-18 weight-bold darkergray--text">About</span>
                            </div>
                            <span class="primary--text pt-1 font-15 weight-medium" v-if="doctor.professional_exp">{{ doctor.professional_exp }} Years Of Experience</span>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <span v-if="doctor.about" class="font-14 weight-regular darkergray--text">
                                  {{ doctor.about }}
                              </span>
                              <span v-else class="font-14 weight-regular">
                                  No Information Provided
                              </span>
                            </v-col>
                          </v-row>
                          <v-divider class="py-2"></v-divider>
                          <v-row no-gutters class="d-flex justify-space-between">
                            <div>
                              <v-avatar
                                  tile
                                  color="white"
                                  size="36"
                                  class="mr-3"
                              >
                                <v-icon color="primary">
                                  mdi-toolbox-outline
                                </v-icon>
                              </v-avatar>
                              <span class="font-18 weight-bold darkergray--text">Services</span>
                            </div>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <span v-if="doctor.services" class="font-14 weight-regular darkergray--text">
                                  {{ doctor.services }}
                              </span>
                              <span v-else class="font-14 weight-regular">
                                  No Information Provided
                              </span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6" lg="6">
                              <v-card  class="rounded-card card-shadow">
                                <v-card-title>
                                  <v-avatar
                                      tile
                                      color="white"
                                      size="36"
                                      class="mr-3"
                                  >
                                    <v-icon color="primary">
                                      mdi-school
                                    </v-icon>
                                  </v-avatar>
                                  <span class="font-15 weight-semibold darkergray--text">Education</span>
                                </v-card-title>
                                <v-card-text v-if="doctor.education">
                                  <div class="px-2">
                                    <div class="font-13 weight-regular darkergray--text">
                                      {{doctor.education.degree_name}}
                                    </div>
                                    <div class="font-13 weight-regular darkergray--text">
                                      {{doctor.education.institute_name}} - {{doctor.education.year}}
                                    </div>
                                  </div>                              
                                </v-card-text>
                                <v-card-text v-else>
                                    -       
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col cols="12" md="6" lg="6">
                              <v-card class="rounded-card card-shadow">
                                <v-card-title>
                                  <v-avatar
                                      tile
                                      color="white"
                                      size="36"
                                      class="mr-3"
                                  >
                                    <v-icon color="primary">
                                      mdi-doctor
                                    </v-icon>
                                  </v-avatar>
                                  <span class="font-15 weight-semibold darkergray--text">Registration</span>
                                </v-card-title>
                                <v-card-text v-if="doctor.registration">
                                  <div class="px-2">
                                    <div class="font-13 weight-regular darkergray--text">
                                        {{doctor.registration.registration_number}}
                                    </div>
                                    <div class="font-13 weight-regular darkergray--text">
                                      {{doctor.registration.council}} - {{doctor.registration.year}}
                                    </div>                              
                                  </div>
                                </v-card-text>
                                <v-card-text v-else>
                                    -       
                                </v-card-text>
                              </v-card>
                            </v-col>

                            <v-col cols="12" md="12" v-if="1==0">
                              <v-card class="rounded-card card-shadow">                            
                                <v-card-text>
                                  <v-row no-gutters>
                                    <v-col cols="12" md="3">
                                      <span class="font-15 weight-semibold darkergray--text">Registration</span>                              
                                    </v-col>
                                    <v-col cols="12" md="9" class="d-flex justify-end">
                                      <span class="font-14 weight-medium primary--text">{{doctor.registration.registration_number}} - {{doctor.registration.council}} - {{doctor.registration.year}}</span>                              
                                    </v-col>
                                  </v-row>
                                  
                                </v-card-text>
                              </v-card>
                            </v-col>

                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" class="mt-8">
                      
                        <v-tabs
                        active-class="active_tab"
                        
                          color="darkergray"
                          slider-color="lightgray"
                            v-model="tab"
                        >
                          <v-tabs-slider style="height:0px !important;" color="darkgray"></v-tabs-slider>
                          <v-tab
                              v-for="i in tabs"
                              :key="i.key"
                              :href="`#tab-${i.key}`"
                          >
                                                      <span class="hidden-sm-and-down">
                                                          {{ i.title }}&nbsp;
														<span class="" v-if="i.key == 'rating_review'">
                                                          <template v-if="doctor.total_ratings">({{ doctor.total_ratings }})</template>
														  <template v-else>(0)</template>
														</span>
														<span class="" v-else-if="i.key == 'q_a'">
                                                          ({{ questionsList.length }})
														</span>
                                                      </span>
													  
													<span class="hidden-md-and-up">
                                                          <v-icon v-text="i.icon" color="primary"></v-icon>&nbsp;
														  <span class="" v-if="i.key == 'rating_review'">
															  <template v-if="doctor.total_ratings">({{ doctor.total_ratings }})</template>
															  <template v-else>(0)</template>
															</span>
															<span class="" v-else-if="i.key == 'q_a'">
															  ({{ questionsList.length }})
															</span>
                                                      </span>
                          </v-tab>
                          <v-tab-item value="tab-rating_review">
                            <v-card class="mb-2 card-shadow">
                              <v-card-text>
                                <v-row v-if="reviewSectionLoading" class="text-center">
                                  <v-col cols="12">
                                    <br><br><br>
                                    <v-progress-circular
                                        size="50"
                                        color="primary"
                                        indeterminate
                                    ></v-progress-circular>
                                    <br><br><br>
                                  </v-col>
                                </v-row>
                                <template v-else>
                                                     <v-col cols="12" sm="12" class="text-center">
                                                       <v-btn v-if="show_review === false" @click="giveReview()" class="secondaryVariant white--text mt-4"
                                                              rounded>
                                                         Give Review
                                                         <v-icon right>mdi-arrow-right</v-icon>
                                                       </v-btn>
                                                      </v-col>

                                  <v-form v-if="show_review === true">
                                    <v-row no-gutters class="ml-3 mr-3 mt-2">
                                      <v-col cols="12">
                                        <h4>Would you recommend this doctor to others?</h4>
                                      </v-col>
                                      <v-col cols="12">

                                        <v-chip-group
                                            mandatory
                                            v-model="reviewIsrecommended"
                                            active-class="green--text text--accent-4"
                                        >
                                          <v-chip
                                              :outlined="reviewIsrecommended==='false'"
                                              class="mr-2"
                                              color="green"
                                              small
                                              value=true
                                          >
                                            <span :class="reviewIsrecommended==='true' ? 'white--text' : 'green-text' ">Yes</span>

                                            <v-icon small :color="reviewIsrecommended==='true' ? 'white' : 'green' " right>mdi-thumb-up</v-icon>
                                          </v-chip>
                                          <v-chip
                                              small
                                              value=false
                                              :outlined="reviewIsrecommended==='true'"
                                              color="red"
                                          >
                                            <span  :class="reviewIsrecommended==='false' ? 'white--text' : 'red-text' ">No</span>

                                            <v-icon small right :color="reviewIsrecommended==='false' ? 'white' : 'red' ">mdi-thumb-down</v-icon>
                                          </v-chip>
                                        </v-chip-group>
                                      </v-col>
                                      <v-col cols="12" sm="12" class="mt-5">
                                        <v-textarea placeholder="How was your experience?" solo flat rows=2
                                                    background-color="grey lighten-3"
                                                    v-model="reviewDescription"></v-textarea>
                                      </v-col>


                                      <v-col cols="12" sm="12" class="text-center">
                                        <v-btn @click.prevent="submitReview" class="accent white--text"
                                              :loading="reviewLoading"
                                              :disabled="reviewLoading"
                                              rounded>
                                          Submit Review
                                          <v-icon right>mdi-arrow-right</v-icon>
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="12" sm="12" class="text-center mt-4">
                                        <v-divider></v-divider>
                                      </v-col>

                                    </v-row>
                                  </v-form>
                                  <template v-if="show_review === false">
                                    <v-list v-if="reviews.length">

                                      <template v-for="(review, index) in reviews">
                                        <v-list-item :key="review.id">       
                                                                    
                                          <v-row>
                                            <v-col cols="12" md="6">
                                              <b class="mb-2 font-14 weight-semibold darkergray--text">{{ review.patient.name }}</b>
                                            </v-col>
                                            <v-col cols="12" md="6" class="weight-regular font-14 primary--text text-md-right">
                                              {{ dateutils.utcToLocal(review.updated_at).format('DD MMM, YYYY')  }}
                                            </v-col>
                                            <v-col cols="12" class="pt-1">
                                              <span>
                                                  <div v-if="review.is_recommended===true" class="green--text">
                                                      <v-icon small class="mr-2" color="green">mdi-thumb-up-outline</v-icon>I recommend this doctor
                                                  </div>
                                                  <v-list-item-subtitle v-if="review.is_recommended===false" class="red--text">
                                                      <v-icon small class="mr-2" color="red">mdi-thumb-down-outline</v-icon>I do not recommend this doctor
                                                  </v-list-item-subtitle>
                                              </span>
                                            </v-col>
                                            <v-col cols="12" class="pt-1">
                                              
                                              <span class="font-14 weight-regular darkgray--text">
                                                {{ review.description }}
                                              </span>
                                            </v-col>
                                          </v-row>
                                          
                                        
                                        </v-list-item>
                                        <v-divider :key="index" v-if="index + 1 < reviews.length"></v-divider>
                                      </template>
                                    </v-list>
                                    <div v-if="reviews.length === 0" class="text-center ">
                                      <!--                        <v-icon large>mdi-alert</v-icon>-->
                                      <!--                        <br>-->
                                      <h3 class="font-weight-regular">No Ratings or Reviews Found</h3>
                                    </div>
                                  </template>
                                </template>

                              </v-card-text>
                            </v-card>
                          </v-tab-item>

                          <v-tab-item
                              value="tab-q_a"
                          >
                            <v-card class="mb-2 card-shadow">
                              <v-card-text>
                                <v-col cols="12" sm="12" md="12" class="pa-0 question-list">

                                  <div class="py-0">
                                    <div                                                                        
                                        v-for="(question, key) in questionsList"
                                        :key="key">

                                        <div class="my-4">                                          
                                          <span @click="$router.push({name: 'askAQuestionDetail', params: {id: question.id, slug: getSlugFromString(question.title)}})" class="font-14 weight-semibold darkergray--text cursor-pointer" v-if="question.title">{{ question.title }}</span>
                                          <div @click="$router.push({name: 'askAQuestionDetail', params: {id: question.id, slug: getSlugFromString(question.title)}})" v-text="question.description" class="my-2 font-14 weight-regular darkgray--text cursor-pointer"></div>

                                          <div>
                                            <div v-if="question.answers.length" class="my-2 font-14 weight-regular darkgray--text">
                                              <template v-if="question.answers[0].response.length < readmoreLength ">
                                                {{ question.answers[0].response }}
                                              </template>
                                              <template v-else>
                                                <template v-if="question.more">
                                                  {{ question.answers[0].response }}
                                                </template>
                                                <template v-else>
                                                  {{ question.answers[0].response.slice(0,readmoreLength) }}....
                                                </template>
                                                                                                
                                                <div class="font-12 weight-medium text-right cursor-pointer" v-if="!question.more" @click="expand(question,key)">Read More</div>
                                                <div class="font-12 weight-medium text-right cursor-pointer" v-if="question.more == true" @click="collapse(question,key)">Read Less</div>
                                              </template>                                                                                            
                                            </div>
                                          </div>
                                          <a class="darkergray--text font-12 weight-semibold" v-if="question.total_answers -1 > 0" @click="$router.push({name: 'askAQuestionDetail', params: {id: question.id}})">
                                            {{ question.total_answers -1 }} more answers
                                          </a>
                                          <v-row no-gutters>
                                            <v-col cols="6" class="text-left weight-regular font-12" v-if="question.patient">
                                              {{ question.patient.gender | capitalize}}, {{ question.patient.birth_year | age }}
                                            </v-col>
                                            <v-col cols="12" class="text-right weight-regular font-12">
                                              {{ dateutils.utcToLocal(question.created_at).format('M MMM \'YY, hh:mm A')  }}
                                            </v-col>
                                          </v-row>          
                                        </div>                            
                                        <v-divider class="" :key="key" v-if="key + 1 < questionsList.length"></v-divider>
                                    </div>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="pa-0 question-list">
                                  <div class="text-center " v-if="!questionsList.length">
                                    <!--                    <v-icon large>mdi-alert</v-icon>-->
                                    <!--                    <br>-->
                                    <h3 class="font-weight-regular">No Question or Answers Found</h3>
                                  </div>
                                </v-col>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs>
                      
                    </v-col>
                  </v-row>
                  
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="4" class="ma-0 py-0" >
                  <v-row no-gutters>        
                    <v-col cols="12" class="ma-0 py-0">
                      <v-row>
                        <v-col cols="12" v-if="onlineConsultation && doctor.available_online">
                          <v-card class="card-shadow">


                            <v-card-title class="font-18 weight-bold darkergray--text ml-3">
                              <v-icon class="primary--text">mdi-video-outline</v-icon>
                              <span class="ml-3">Video Consultation</span></v-card-title>
                            <v-card-text>
                              <v-list class="wrap-normal-list" v-if="onlineConsultationLoading">
                                <template>
                                  <v-list-item >
                                    <v-list-item-content class="d-flex flex-center">
                                      <v-progress-circular
                                          indeterminate
                                          color="primary"
                                      ></v-progress-circular>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-list>
                              <v-list class="wrap-normal-list" v-else>

                                <template v-if="onlineConsultation && doctor.available_online">
                                  <v-list-item class="px-1">
                                    <v-list-item-avatar class="align-self-start">
                                      <v-icon color="darkergray" >mdi-clock</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <template v-if="onlineConsultation.schedule.length">
                                        <v-list-item-subtitle v-for="(schedule,index) in onlineConsultation.schedule" :key="schedule.id">
                                          <v-divider v-if="schedule.header && index!==0" class="mt-2 mb-2"></v-divider>
                                          <div class="mt-2 font-13 weight-regular darkergray--text" v-if="schedule.header">

                                            {{  moment().day(schedule.day).format('dddd')}}
                                          </div>
                                          <div class="mt-1 font-13 weight-regular darkergray--text" v-else>
                                            {{ moment(schedule.start_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }} to {{ moment(schedule.end_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }}
                                          </div>
                                        </v-list-item-subtitle>
                                      </template>
                                      <v-list-item-subtitle v-else>
                                        <div>
                                          No Schedule
                                        </div>
                                      </v-list-item-subtitle>

                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <v-list-item>
                                    <v-list-item-avatar>
                                      <v-icon color="darkergray">mdi-currency-inr</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content v-if="onlineConsultation.fee">
                                      <v-list-item-subtitle class="font-13 weight-regular darkergray--text">
                                        <b>Fees: Rs. {{ onlineConsultation.fee.amount }}</b>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <v-list-item v-if="onlineConsultation.fee && onlineConsultation.schedule.length">
                                    <v-list-item-content style="display:block !important;">
                                      <v-btn
                                          block
                                          depressed
                                          @click.prevent="" color="#D9F7FF" class="black--text"
                                          @click="goForBooking(doctor.id,null,'online')"
                                      >Book Appointment Now
                                      </v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                                <v-list-item v-else>
                                  <v-list-item-content>
                                    <v-list-item-subtitle class="black--text text-center">
                                      Video consultation is unavailable
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" v-if="!clinicLoading && clinicsList.length && doctor.available_clinic">
                          <v-card class="card-shadow">
                            
                            <v-card-text class="">
                              <div class="ml-3 pb-0">
                              <span class="icon_box">
                                <v-icon class="primary--text">mdi-hospital-box-outline</v-icon>
                              </span>
                              <span class="font-18 weight-bold darkergray--text ml-3">
                                Clinic Appointment
                              </span>                              
                            </div>
                              <v-list class="wrap-normal-list py-0 my-0" v-if="clinicLoading">
                                <template>
                                  <v-list-item >
                                    <v-list-item-content class="d-flex flex-center">
                                      <v-progress-circular
                                          indeterminate
                                          color="primary"
                                      ></v-progress-circular>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-list>
                              <v-list  class="wrap-normal-list" v-else-if="!clinicLoading && clinicsList.length && doctor.available_clinic">
                                <v-list-group
                                    v-for="(clinic,index) in clinicsList"
                                    :key="clinic.id"                                    
                                    no-action
									:value="index == 0 ? 'true' : 'true'"											
                                >
                                  <template v-slot:activator>
                                    <v-list-item-content>
                                      <v-col cols="12" sm="12" md="7" class="pl-0 pt-0 pb-0 pr-0">
                                        <v-list-item-title class="font-15 weight-medium grey--text text--darken-3" v-text="clinic.name"></v-list-item-title>
                                      </v-col>

                                    </v-list-item-content>
                                  </template>
                                  <v-divider></v-divider>
                                  <v-list-item class="pl-0">
                                    <v-list-item-avatar>
                                      <v-icon color="darkergray">mdi-map-marker</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-subtitle class="d-flex justify-space-between align-center">
                                        <div class="font-13 weight-regular darkergray--text">
                                          {{clinic.address}}
                                        </div>
                                        <v-btn @click.prevent="openMap(clinic)" x-small class="secondaryVariant white--text" depressed>
                                          View On Map
                                        </v-btn>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <v-list-item class="pl-0">
                                    <v-list-item-avatar class="align-self-start">
                                      <v-icon  color="darkergray">mdi-clock</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <template v-if="clinic.doctor_schedule.length">
                                        <v-list-item-subtitle v-for="(schedule,index) in clinic.doctor_schedule" :key="schedule.id">
                                          <v-divider v-if="schedule.header && index!==0" class="mt-2 mb-2"></v-divider>
                                          <div class="mt-2 font-13 weight-regular darkergray--text" v-if="schedule.header">
                                            {{  moment().day(schedule.day).format('dddd')}}
                                          </div>
                                          <div class="mt-1 font-13 weight-regular darkergray--text" v-else>

                                            {{ moment(schedule.start_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }} to {{ moment(schedule.end_time, [moment.ISO_8601, 'HH:mm:ss']).format('hh:mm A') }}
                                          </div>

                                        </v-list-item-subtitle>
                                      </template>
                                      <v-list-item-subtitle v-else>
                                        <div class="mt-2 font-13 weight-regular darkergray--text">
                                          No Schedule
                                        </div>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <v-list-item class="pl-0">
                                    <v-list-item-avatar>
                                      <v-icon color="darkergray">mdi-currency-inr</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content v-if="clinic.fees.length">
                                      <v-list-item-subtitle class="font-13 weight-regular darkergray--text">
                                        <b>Fees: Rs. {{clinic.fees[0].amount}}</b>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-content v-else>
                                      <v-list-item-subtitle class="black--text">
                                        <b>Not Mentioned</b>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider></v-divider>
                                  <v-list-item class="px-0" v-if="clinic.fees[0] && clinic.doctor_schedule.length">
                                    <v-list-item-content v-if="clinic.fees[0]" >
                                      <v-btn  @click.prevent="" block depressed color="#D9F7FF" class="darkerGray--text weight-bold"
                                            @click="goForBooking(doctor.id,clinic,'clinic')"
                                      >Book Appointment Now
                                      </v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-group>


                              </v-list>
                              <v-list v-else>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-subtitle class="black--text text-center">
                                      Clinic consultation is unavailable
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  
                  </v-row>
                </v-col>
        </v-row>

      
    </v-container>
    <v-dialog v-model="loginDialog" max-width="900" persistent>
      <v-card>
        <patient-login @loginResult="loginDone"></patient-login>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn text @click.prevent="loginDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog
          v-model="cantReviewDialog"
          persistent
          max-width="290"
      >

        <v-card>
          <v-card-title class="headline">
            Review
          </v-card-title>
          <v-card-text>You cannot review this doctor since you did not have any interaction.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                text
                @click="cantReviewDialog = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
 import PatientLogin from "@/components/Login/PatientLogin";

export default {
  name: "DoctorDetails",
  components: {
     PatientLogin
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
  },
  props: ['doctorId', 'showBooking'],

  data() {
    return {
      apiUrl:process.env.VUE_APP_API_URL,
      loginDialog: false,
      detailsLoading: false,
      doctor: {
        education: {},
        registration: {},
        clinics: []
      },
      alignRight: {
        float:'right'
      },
      menu: false,
      tab: 1,
      tabs: [
        {
          'title': 'Ratings & Reviews',
          'key': 'rating_review',
          'icon' : 'mdi-thumb-up-outline',
		  
        },
        {
          'title': 'Q & A',
          'key': 'q_a',
          'icon' : 'mdi-forum-outline',
		  'count':0
        }
      ],
      reviews:[],
      reviewIsrecommended:null,
      reviewDescription:"",
      show_review:false,
      reviewLoading:false,
      questionsList:[],
      clinicsList:[],
      onlineConsultation:null,
      isMyDoctor:null,
      reviewSectionLoading:false,
      cantReviewDialog:false,
      clinicLoading:false,
      onlineConsultationLoading:false,
      readmoreLength:200
    };

  },
  methods: {
    loginDone() {
      this.loginDialog = false;
    },
    getReviews() {

      this.axios.get(`${process.env.VUE_APP_API_URL}/api/ratings`,{
        params:{
          doctor_id:this.doctor.id
        }
      }).then((response) => {
        if(response.data.status == 1){

          this.reviews  = response.data.data

        }

      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {

          })
    },
    giveReview(){
      if (!this.userInfo) {
        this.loginDialog = true;
        return;
      }
      else{
        this.getIsMyDoctor()
      }

    },
    submitReview() {
      if (!this.userInfo) {
        this.loginDialog = true;
        return;
      }
      this.reviewLoading = true
      this.axios.post(`${process.env.VUE_APP_API_URL}/api/ratings/doctor/` + this.doctor.id,{

        is_recommended:this.reviewIsrecommended,
        description:this.reviewDescription,
        patient_id:this.userInfo.id,


      }).then((response) => {
        if(response.data.status == 1){
          this.show_review = false
          this.reviewDescription = ""
          this.getReviews()
        }

      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {
            this.reviewLoading = false
          })
    },
    getQuestions() {

      this.axios.get(`${process.env.VUE_APP_API_URL}/api/questions`,{
        params:{
          doctor_id:this.doctor.id,
          my_answers:true
        }
      }).then((response) => {
        if(response.data.status == 1){
          this.questionsList  = response.data.data
        }
      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {

          })
    },
    getDoctorProfile() {
      this.detailsLoading = true
      const request = this.axios.get(`${process.env.VUE_APP_API_URL}/api/doctors/no/${this.$route.params.unique_no}`)
        return request.then((response) => {          
            this.doctor = response.data.data            
          })
          .catch(() => {})
          .finally(() => {
            this.detailsLoading = false
          })
    },
    getClinicsAndSchedule() {
      this.clinicLoading = true;
      this.axios.get(`${process.env.VUE_APP_API_URL}/api/clinics/doctor/`+this.doctor.id,{
        params:{
          timezone:this.$store.getters.timezone
        }
      }).then((response) => {
        var clinicData;
        if(response.data.status == 1){
          clinicData  = response.data.data
          for(var i=0; i< clinicData.length;i++){
            var doctorSchedule = clinicData[i].doctor_schedule;
            clinicData[i].doctor_schedule = this.generateHeaders( doctorSchedule)
          }
          this.clinicsList  = clinicData;
        }
      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {
            this.clinicLoading = false;
          })
    },
    getOnlineConsultationSchedule() {
      this.onlineConsultationLoading = true
      this.axios.get(`${process.env.VUE_APP_API_URL}/api/doctors/`+this.doctor.id+"/doctor-online-consultation-info",
          {
            params:{
              timezone:this.$store.getters.timezone
            }
          }).then((response) => {
        var consultationData;
        if(response.data.status == 1){
          consultationData = response.data.data

          if(consultationData && consultationData.schedule.length)
            consultationData.schedule = this.generateHeaders(response.data.data.schedule)

          this.onlineConsultation = consultationData
        }
      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {
            this.onlineConsultationLoading = false
          })
    },

    generateHeaders(schedule){
      var newList = schedule;
      var currentDay = null;
      for(var i=0; i< schedule.length;i++){
        let obj = JSON.parse(JSON.stringify(schedule[i]));
        if(currentDay !== obj.day){
          obj.header = true
          newList.splice(i,0,obj)
        }
        currentDay = obj.day;
      }

      return newList;
    },
    goForBooking(doctorId, clinic,apptType) {

      var clinic_id = ""
      if(apptType == 'clinic'){
        clinic_id = clinic.id
      }
      this.$router.push({name: 'bookAppointment', query: {id: doctorId, type: apptType, clinic_id:clinic_id}});
    },
    getIsMyDoctor() {
      this.reviewSectionLoading = true;
      this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/doctor/`+this.doctor.id+`/can-rate-doctor`,{
        params:{
          doctor_id:this.doctor.id
        }
      }).then((response) => {
        if(response.data.status == 1){

          this.isMyDoctor  = response.data.data
          if(this.isMyDoctor){
            this.show_review = true
          }
          else{
            this.show_review = false
            this.cantReviewDialog = true;
          }
        }

      }).catch((error) => {
        console.log(error)
      })
          .finally(() => {
            this.reviewSectionLoading = false;
          })
    },
    openMap(clinic){
      var link ='https://www.google.com/maps/search/?api=1&query=' + clinic.latitude + ',' + clinic.longitude
      window.open(link);
    },
    getRecommendations(doctor){
        var count = doctor.total_ratings;
        if(count == null || count == undefined)
          count = 0        
        if(count == 0)
            return "No Recommendation"
        else
            return count + " Recommendations"                                
    },
    expand(question,index){
      question.more = true 
      this.questionsList.splice(index,question)     
    },
    collapse(question,index){
      question.more = false       
      this.questionsList.splice(index,question)     
    }
  },
  mounted(){
    
    let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://platform-api.sharethis.com/js/sharethis.js#property=601282879997ac0011195766&product=inline-share-buttons')
            recaptchaScript.setAttribute('aync', 'async');            
            document.head.appendChild(recaptchaScript)
    this.getDoctorProfile().then(()=>{                        
      this.getReviews()
      this.getQuestions()
      this.getClinicsAndSchedule()
      this.getOnlineConsultationSchedule()
    })
    
  },
  filters: {
    // readableDateTime: function (value) {
    //     return this.moment(value).format('hh:mm A, D MMM YYYY')
    // },
    // age: function (value) {
    //     return parseInt(this.moment().year()) - parseInt(value) + ' Years'
    // },
    // capitalize: function (value) {
    //     return value !== undefined ? value.charAt(0).toUpperCase() + value.slice(1) : ''
    // },

  },

}
</script>
<style lang="scss">
#doctor-details {
  .profile-image {
    margin-top: -50% !important;
  }
  .rounded-card {
    border-radius: 10px;
  }
}

.active_tab{
  color:#efefef;
  background:#f5f5f5;
  font-weight: 600;
  border-left:1px solid #afafaf;
  border-top:1px solid #afafaf;
  border-bottom:1px solid #afafaf;
  border-right:1px solid #afafaf;  
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  
}
// .icon_box{
//     background:#f4f9ff;
//     border-radius: 6px;
//     padding:8px;
//   }
</style>

